{
    "categories": {
        "telemetry": {
            "title": {
                "zh_CN": {
                    "name": "categories.displayName.telemetry",
                    "value": "遥测"
                },
                "fr": {
                    "name": "categories.displayName.telemetry",
                    "value": "Télémétrie"
                },
                "ru": {
                    "name": "categories.displayName.telemetry",
                    "value": "Telemetry"
                },
                "ja": {
                    "name": "categories.displayName.telemetry",
                    "value": "製品利用統計情報"
                },
                "zh_TW": {
                    "name": "categories.displayName.telemetry",
                    "value": "Telemetry"
                },
                "it": {
                    "name": "categories.displayName.telemetry",
                    "value": "Telemetria"
                },
                "ko": {
                    "name": "categories.displayName.telemetry",
                    "value": "원격 측정"
                },
                "pt_BR": {
                    "name": "categories.displayName.telemetry",
                    "value": "Telemetria"
                },
                "da": {
                    "name": "categories.displayName.telemetry",
                    "value": "Telemetri"
                },
                "de": {
                    "name": "categories.displayName.telemetry",
                    "value": "Telemetrie"
                },
                "fi": {
                    "name": "categories.displayName.telemetry",
                    "value": "Telemetria"
                },
                "es": {
                    "name": "categories.displayName.telemetry",
                    "value": "Telemetría"
                },
                "en": {
                    "name": "categories.displayName.telemetry",
                    "value": "Telemetry"
                },
                "sv": {
                    "name": "categories.displayName.telemetry",
                    "value": "Telemetri"
                },
                "pt_PT": {
                    "name": "categories.displayName.telemetry",
                    "value": "Telemetria"
                },
                "nl": {
                    "name": "categories.displayName.telemetry",
                    "value": "Telemetrie"
                },
                "no": {
                    "name": "categories.displayName.telemetry",
                    "value": "Telemetri"
                }
            },
            "services": [
                {
                    "name": "hp_proactive_insights",
                    "appSites": ["DAAS_TEST", "DAAS"],
                    "allowTrial": true,
                    "trialPlan": "hp_proactive_insights_trial",
                    "isVisibleToAppSwitcher": true,
                    "isVisibleToMyService": true,
                    "isVisibleToAllService": true,
                    "isVisibleToHelpSupport": true,
                    "isVisibleToLanding": true,
                    "isVisibleForTryIt": true,
                    "launchUrl": "/pi",
                    "displayName": {
                        "zh_CN": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "fr": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "ru": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "ja": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "zh_TW": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "it": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "ko": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "pt_BR": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "da": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "de": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "fi": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "es": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "en": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "sv": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "pt_PT": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "nl": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        },
                        "no": {
                            "name": "services.displayName.hp_proactive_insights",
                            "value": "Proactive Insights"
                        }
                    },
                    "details": {
                        "detailsUrl": "/pi",
                        "redirectUrls": null
                    },
                    "icon": {
                        "initials": "PI",
                        "textColor": "#212121",
                        "bgColor": "#CAF3FF",
                        "fillColor": "#3AB4EB"
                    },
                    "isInternal": true,
                    "defaultOnboardingStatus": "PENDING",
                    "onboardUrl": "signup?service=hp_proactive_insights",
                    "description": {
                        "zh_CN": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "主动发现和解决各种设备问题，避免意外中断影响员工的工作效率。"
                        },
                        "fr": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "Identifiez et résolvez de manière proactive les problèmes de périphériques afin de limiter les interruptions de productivité non planifiées pour votre personnel."
                        },
                        "ru": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "Proactively identify and resolve device issues to mitigate unplanned productivity disruptions for your workforce."
                        },
                        "ja": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "デバイスの問題をプロアクティブに特定して解決することで、従業員の生産性の予期しない低下を防ぎます。"
                        },
                        "zh_TW": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "Proactively identify and resolve device issues to mitigate unplanned productivity disruptions for your workforce."
                        },
                        "it": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "Identifica e risolvi in modo proattivo i problemi dei dispositivi per ridurre le interruzioni di produttività non pianificate della tua forza lavoro."
                        },
                        "ko": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "장치 문제를 사전에 파악하고 해결하여 직원의 예기치 않은 생산성 중단을 완화할 수 있습니다."
                        },
                        "pt_BR": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "Identifique e resolva proativamente problemas de dispositivos para mitigar interrupções de produtividade não planejadas da sua força de trabalho."
                        },
                        "da": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "Du kan proaktivt identificere og afhjælpe problemer, så det undgås, at medarbejderne oplever uforudsete afbrydelser i produktionen."
                        },
                        "de": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "Identifizieren und beheben Sie Geräteprobleme proaktiv, um ungeplante Unterbrechungen der Produktivität für Ihre Benutzerinnen und Benutzer möglichst gering zu halten."
                        },
                        "fi": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "Tunnista ja ratkaise laiteongelmia ennakoivasti vähentääksesi henkilöstön tuottavuutta häiritseviä tekijöitä."
                        },
                        "es": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "Identifique problemas proactivamente y resuélvalos para evitar interrupciones no planificadas que interfieran con la productividad de su personal."
                        },
                        "en": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "Proactively identify and resolve device issues to mitigate unplanned productivity disruptions for your workforce."
                        },
                        "sv": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "Var proaktiv med att identifiera och lösa enhetsproblem för att reducera oplanerade driftstörningar för anställda."
                        },
                        "pt_PT": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "Identifique e solucione proativamente os problemas nos dispositivos para mitigar as interrupções não planeadas na produtividade para o seu pessoal."
                        },
                        "nl": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "Identificeer proactief problemen met apparaten en los deze op om ongeplande onderbrekingen in de productiviteit voor uw medewerkers te beperken."
                        },
                        "no": {
                            "name": "services.description.hp_proactive_insights",
                            "value": "Identifiser og løs enhetsproblemer på en proaktiv måte for å redusere uplanlagte produktivitetsavbrudd for arbeidsstyrken."
                        }
                    },
                    "learnMoreLinks": {
                        "da": "",
                        "de": "https://www.hp.com/de-de/services/proactive-insights.html",
                        "en": "https://www.hp.com/us-en/services/proactive-insights.html",
                        "es": "https://www.hp.com/es-es/services/proactive-insights.html",
                        "fi": "",
                        "fr": "https://www.hp.com/fr-fr/services/proactive-insights.html",
                        "it": "https://www.hp.com/it-it/services/proactive-insights.html",
                        "ja": "",
                        "no": "",
                        "nl": "",
                        "pt-BR": "",
                        "pt-PT": "https://www.hp.com/pt-pt/services/proactive-insights.html",
                        "sv": "",
                        "zh-CN": ""
                    },
                    "imageLink": "/techpulse_assets/images/adminx_services_proactive_insights.jpg",
                    "allowActivationEmail": true,
                    "allowExpirationEmail": true
                }
            ],
            "icon": {
                "initials": "Telemetry",
                "textColor": "#212121",
                "bgColor": "#CAF3FF",
                "fillColor": "#3AB4EB"
            }
        },
        "security": {
            "title": {
                "zh_CN": {
                    "name": "categories.displayName.security",
                    "value": "安全性"
                },
                "fr": {
                    "name": "categories.displayName.security",
                    "value": "Sécurité"
                },
                "ru": {
                    "name": "categories.displayName.security",
                    "value": "Security"
                },
                "ja": {
                    "name": "categories.displayName.security",
                    "value": "セキュリティ"
                },
                "zh_TW": {
                    "name": "categories.displayName.security",
                    "value": "Security"
                },
                "it": {
                    "name": "categories.displayName.security",
                    "value": "Sicurezza"
                },
                "ko": {
                    "name": "categories.displayName.security",
                    "value": "보안"
                },
                "pt_BR": {
                    "name": "categories.displayName.security",
                    "value": "Segurança"
                },
                "da": {
                    "name": "categories.displayName.security",
                    "value": "Sikkerhed"
                },
                "de": {
                    "name": "categories.displayName.security",
                    "value": "Sicherheit"
                },
                "fi": {
                    "name": "categories.displayName.security",
                    "value": "Tietoturva"
                },
                "es": {
                    "name": "categories.displayName.security",
                    "value": "Seguridad"
                },
                "en": {
                    "name": "categories.displayName.security",
                    "value": "Security"
                },
                "sv": {
                    "name": "categories.displayName.security",
                    "value": "Säkerhet"
                },
                "pt_PT": {
                    "name": "categories.displayName.security",
                    "value": "Segurança"
                },
                "nl": {
                    "name": "categories.displayName.security",
                    "value": "Beveiliging"
                },
                "no": {
                    "name": "categories.displayName.security",
                    "value": "Sikkerhet"
                }
            },
            "services": [
                {
                    "name": "hp_protect_and_trace",
                    "appSites": ["DAAS_TEST", "DAAS"],
                    "allowTrial": false,
                    "trialPlan": "hp_protect_and_trace_trial_package",
                    "isVisibleToAppSwitcher": true,
                    "isVisibleToMyService": true,
                    "isVisibleToAllService": true,
                    "isVisibleToHelpSupport": true,
                    "isVisibleToLanding": true,
                    "launchUrl": "/flip",
                    "displayName": {
                        "zh_CN": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "fr": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "ru": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "ja": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "zh_TW": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "it": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "ko": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "pt_BR": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "da": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "de": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "fi": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "es": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "en": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "sv": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "pt_PT": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "nl": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        },
                        "no": {
                            "name": "services.displayName.hp_protect_and_trace",
                            "value": "Wolf Protect & Trace"
                        }
                    },
                    "details": {
                        "detailsUrl": "/flip",
                        "redirectUrls": null
                    },
                    "icon": {
                        "initials": "WP",
                        "textColor": "#212121",
                        "bgColor": "#B7F9EE",
                        "fillColor": "#8AF0DF"
                    },
                    "isInternal": true,
                    "defaultOnboardingStatus": "PENDING",
                    "description": {
                        "zh_CN": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "fr": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "ru": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "ja": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "zh_TW": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "it": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "ko": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "pt_BR": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "da": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "de": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "fi": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "es": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "en": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "sv": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "pt_PT": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "nl": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        },
                        "no": {
                            "name": "services.description.hp_protect_and_trace",
                            "value": "Locate, lock and securely erase PCs from a remote, self-managed location. "
                        }
                    },
                    "learnMoreLinks": {
                        "da": "",
                        "de": "https://www.hp.com/de-de/services/security.html",
                        "en": "https://www.hp.com/us-en/services/security.html",
                        "es": "https://www.hp.com/es-es/services/security.html",
                        "fi": "",
                        "fr": "https://www.hp.com/fr-fr/services/security.html",
                        "it": "https://www.hp.com/it-it/services/security.html",
                        "ja": "",
                        "no": "",
                        "nl": "",
                        "pt-BR": "https://www.hp.com/br-pt/services/security.html",
                        "pt-PT": "https://www.hp.com/pt-pt/services/security.html",
                        "sv": "https://www.hp.com/se-sv/services/security.html",
                        "zh-CN": ""
                    },
                    "imageLink": "/techpulse_assets/images/Wolf_Protect_&_Trace.jpg"
                },
                {
                    "name": "hp_protect_and_trace_wolf_connect",
                    "appSites": ["DAAS_TEST", "DAAS"],
                    "allowTrial": true,
                    "trialPlan": "hp_protect_and_trace_always_on",
                    "isVisibleToAppSwitcher": true,
                    "isVisibleToMyService": true,
                    "isVisibleToAllService": true,
                    "isVisibleToHelpSupport": true,
                    "isVisibleToLanding": false,
                    "isFreeActiveService": true,
                    "launchUrl": "/wolf_connect",
                    "displayName": {
                        "zh_CN": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "fr": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "ru": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "ja": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "zh_TW": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "it": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "ko": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "pt_BR": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "da": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "de": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "fi": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "es": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "en": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "sv": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "pt_PT": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "nl": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        },
                        "no": {
                            "name": "services.displayName.hp_protect_and_trace_wolf_connect",
                            "value": "Protect & Trace + Wolf Connect"
                        }
                    },
                    "details": {
                        "detailsUrl": "/wolf_connect",
                        "redirectUrls": null
                    },
                    "icon": {
                        "initials": "WC",
                        "textColor": "#212121",
                        "bgColor": "#B7F9EE",
                        "fillColor": "#8AF0DF"
                    },
                    "isInternal": true,
                    "defaultOnboardingStatus": "PENDING",
                    "onboardUrl": "signup?service=hp_protect_and_trace_always_on",
                    "description": {
                        "zh_CN": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "fr": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "ru": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "ja": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "zh_TW": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "it": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "ko": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "pt_BR": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "da": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "de": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "fi": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "es": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "en": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "sv": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "pt_PT": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "nl": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        },
                        "no": {
                            "name": "services.description.hp_protect_and_trace_wolf_connect",
                            "value": "Locate, lock and securely erase PCs, even when they are offline or powered down."
                        }
                    },
                    "learnMoreLinks": {
                        "da": "",
                        "de": "",
                        "en": "/wolfprotectandtrace",
                        "es": "",
                        "fi": "",
                        "fr": "",
                        "it": "",
                        "ja": "",
                        "no": "",
                        "nl": "",
                        "pt-BR": "",
                        "pt-PT": "",
                        "sv": "",
                        "zh-CN": ""
                    },
                    "imageLink": "/techpulse_assets/images/Protect_&_Trace_with_Wolf_Connect.jpg"
                },
                {
                    "name": "hp_wolf_security",
                    "appSites": ["DAAS_TEST", "DAAS"],
                    "allowTrial": false,
                    "isVisibleToAppSwitcher": true,
                    "isVisibleToMyService": true,
                    "isVisibleToAllService": true,
                    "isVisibleToHelpSupport": true,
                    "isVisibleToLanding": true,
                    "isVisibleForTryIt": false,
                    "isFreeActiveService": true,
                    "launchUrl": "https://www.hpwolf.com/",
                    "displayName": {
                        "zh_CN": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "fr": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "ru": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "ja": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "zh_TW": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "it": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "ko": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "pt_BR": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "da": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "de": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "fi": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "es": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "en": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "sv": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "pt_PT": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "nl": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        },
                        "no": {
                            "name": "services.displayName.hp_wolf_security",
                            "value": "Wolf Security"
                        }
                    },
                    "details": {
                        "detailsUrl": "https://support.hpwolf.com/trial",
                        "redirectUrls": {
                            "HPID": "{baseDomain}/oidc/login/begin/hpid/?next={baseDomain}",
                            "AAD": "{baseDomain}/oidc/login/begin/azuread/tenant/?next={baseDomain}",
                            "default": "{baseDomain}"
                        }
                    },
                    "icon": {
                        "initials": "WS",
                        "textColor": "#212121",
                        "bgColor": "#CAF3FF",
                        "fillColor": "#3AB4EB"
                    },
                    "isInternal": false,
                    "defaultOnboardingStatus": "COMPLETED",
                    "onboardUrl": "https://support.hpwolf.com/trial",
                    "description": {
                        "zh_CN": {
                            "name": "services.description.hp_wolf_security",
                            "value": "从硬件级别开始并扩展到软件和服务，提供全方位端点保护和复原能力。"
                        },
                        "fr": {
                            "name": "services.description.hp_wolf_security",
                            "value": "Protection et résilience complètes des points de terminaison qui commence au niveau du matériel et s’étend aux logiciels ainsi qu’aux services."
                        },
                        "ru": {
                            "name": "services.description.hp_wolf_security",
                            "value": "Comprehensive endpoint protection and resiliency that starts at the hardware level and extends across software and services."
                        },
                        "ja": {
                            "name": "services.description.hp_wolf_security",
                            "value": "ハードウェア レベルから始まりソフトウェアやサービスにまで及ぶ、包括的なエンドポイント保護とレジリエンスを提供します。"
                        },
                        "zh_TW": {
                            "name": "services.description.hp_wolf_security",
                            "value": "Comprehensive endpoint protection and resiliency that starts at the hardware level and extends across software and services."
                        },
                        "it": {
                            "name": "services.description.hp_wolf_security",
                            "value": "Protezione completa degli endpoint e resilienza che parte dal livello hardware e si estende a software e servizi."
                        },
                        "ko": {
                            "name": "services.description.hp_wolf_security",
                            "value": "하드웨어 수준에서 시작해 소프트웨어와 서비스로 확장되는 포괄적인 끝점 보호와 복원력을 제공합니다."
                        },
                        "pt_BR": {
                            "name": "services.description.hp_wolf_security",
                            "value": "Proteção abrangente de terminal e resiliência que começa no nível de hardware e se estende por software e serviços."
                        },
                        "da": {
                            "name": "services.description.hp_wolf_security",
                            "value": "Omfattende endpointbeskyttelse og genoprettelse, der starter på hardwareniveauet og fortsætter til software og tjenester."
                        },
                        "de": {
                            "name": "services.description.hp_wolf_security",
                            "value": "Umfassender Schutz und Resilienz für Endgeräte, der sich von der Hardwareebene bis hin zu Software und Services erstreckt."
                        },
                        "fi": {
                            "name": "services.description.hp_wolf_security",
                            "value": "Kattavaa päätelaitteiden suojausta ja vastustuskykyä, joka alkaa laitetasolta ja jatkuu siitä ohjelmistoihin ja palveluihin."
                        },
                        "es": {
                            "name": "services.description.hp_wolf_security",
                            "value": "Completa protección de terminal y resiliencia que comienza en el nivel del hardware y se expande al software y los servicios."
                        },
                        "en": {
                            "name": "services.description.hp_wolf_security",
                            "value": "Comprehensive endpoint protection and resiliency that starts at the hardware level and extends across software and services."
                        },
                        "sv": {
                            "name": "services.description.hp_wolf_security",
                            "value": "Omfattande enhetsskydd och motståndskraft som börjar vid hårdvarunivån och sprider sig över programvara och tjänster."
                        },
                        "pt_PT": {
                            "name": "services.description.hp_wolf_security",
                            "value": "Proteção abrangente de terminais e resiliência que inicia ao nível do hardware e estende-se ao longo do software e dos serviços."
                        },
                        "nl": {
                            "name": "services.description.hp_wolf_security",
                            "value": "Uitgebreide eindpuntbescherming en weerbaarheid die begint op hardwareniveau en zich uitstrekt over software en services."
                        },
                        "no": {
                            "name": "services.description.hp_wolf_security",
                            "value": "Omfattende endepunktsbeskyttelse og motstandsdyktighet som starter på maskinvarenivå og omfatter både programvarer og tjenester."
                        }
                    },
                    "learnMoreLinks": {
                        "da": "",
                        "de": "",
                        "en": "https://www.hp.com/us-en/security/endpoint-security-solutions.html",
                        "es": "",
                        "fi": "",
                        "fr": "",
                        "it": "",
                        "ja": "",
                        "no": "",
                        "nl": "",
                        "pt-BR": "",
                        "pt-PT": "",
                        "sv": "",
                        "zh-CN": ""
                    },
                    "imageLink": "/techpulse_assets/images/adminx_services_hp_wolf_security.jpg",
                    "baseDomains": {
                        "usdevms": "https://portal2.dev.hpwolf.com",
                        "usperfms": "https://portal2.dev.hpwolf.com",
                        "uspentestms": "https://portal2.dev.hpwolf.com",
                        "usstagingms": "https://portal.staging.hpwolf.com",
                        "usprodms": "https://portal.hpwolf.com",
                        "eudevms": "https://portal2.dev.hpwolf.com",
                        "eustagingms": "https://portal.staging.hpwolf.com",
                        "euprodms": "https://portal.hpwolf.com",
                        "default": "https://portal.hpwolf.com"
                    }
                }
            ],
            "icon": {
                "initials": "Security",
                "textColor": "#212121",
                "bgColor": "#CAF3FF",
                "fillColor": "#8AF0DF"
            }
        },
        "management": {
            "title": {
                "zh_CN": {
                    "name": "categories.displayName.management",
                    "value": "管理"
                },
                "fr": {
                    "name": "categories.displayName.management",
                    "value": "Gestion"
                },
                "ru": {
                    "name": "categories.displayName.management",
                    "value": "Management"
                },
                "ja": {
                    "name": "categories.displayName.management",
                    "value": "管理"
                },
                "zh_TW": {
                    "name": "categories.displayName.management",
                    "value": "Management"
                },
                "it": {
                    "name": "categories.displayName.management",
                    "value": "Gestione"
                },
                "ko": {
                    "name": "categories.displayName.management",
                    "value": "관리"
                },
                "pt_BR": {
                    "name": "categories.displayName.management",
                    "value": "Gerenciamento"
                },
                "da": {
                    "name": "categories.displayName.management",
                    "value": "Administration"
                },
                "de": {
                    "name": "categories.displayName.management",
                    "value": "Verwaltung"
                },
                "fi": {
                    "name": "categories.displayName.management",
                    "value": "Hallinta"
                },
                "es": {
                    "name": "categories.displayName.management",
                    "value": "Administración"
                },
                "en": {
                    "name": "categories.displayName.management",
                    "value": "Management"
                },
                "sv": {
                    "name": "categories.displayName.management",
                    "value": "Hantering"
                },
                "pt_PT": {
                    "name": "categories.displayName.management",
                    "value": "Gestão"
                },
                "nl": {
                    "name": "categories.displayName.management",
                    "value": "Beheer"
                },
                "no": {
                    "name": "categories.displayName.management",
                    "value": "Styring"
                }
            },
            "services": [
                {
                    "name": "hp_command_center",
                    "appSites": ["DAAS_TEST", "DAAS"],
                    "allowTrial": false,
                    "isVisibleToAppSwitcher": true,
                    "isVisibleToMyService": true,
                    "isVisibleToAllService": true,
                    "isVisibleToHelpSupport": false,
                    "isVisibleToLanding": false,
                    "isVisibleForTryIt": true,
                    "isFreeActiveService": false,
                    "launchUrl": "https://hp-commandcenter.com/",
                    "displayName": {
                        "zh_CN": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Command Center"
                        },
                        "fr": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Command Center"
                        },
                        "ru": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Command Center"
                        },
                        "ja": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Command Center"
                        },
                        "zh_TW": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Command Center"
                        },
                        "it": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Command Center"
                        },
                        "ko": {
                            "name": "services.displayName.hp_command_center",
                            "value": "통제 센터"
                        },
                        "pt_BR": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Command Center"
                        },
                        "da": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Command Center"
                        },
                        "de": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Command Center"
                        },
                        "fi": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Komentokeskus"
                        },
                        "es": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Command Center"
                        },
                        "en": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Command Center"
                        },
                        "sv": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Command Center"
                        },
                        "pt_PT": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Command Center"
                        },
                        "nl": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Command Center"
                        },
                        "no": {
                            "name": "services.displayName.hp_command_center",
                            "value": "Command Center"
                        }
                    },
                    "details": {
                        "detailsUrl": "https://hp-commandcenter.com/",
                        "redirectUrls": {
                            "HPID": "{baseDomain}/?email={emailId}&t1={tenantId}",
                            "AAD": "{baseDomain}/?email={emailId}&t1={tenantId}",
                            "default": "{baseDomain}"
                        }
                    },
                    "icon": {
                        "initials": "CC",
                        "textColor": "#212121",
                        "bgColor": "#CAF3FF",
                        "fillColor": "#3AB4EB"
                    },
                    "isInternal": false,
                    "defaultOnboardingStatus": "COMPLETED",
                    "onboardUrl": "https://hp-commandcenter.com/",
                    "description": {
                        "zh_CN": {
                            "name": "services.description.hp_command_center",
                            "value": "使用 HP Command Center v2 监控和管理打印机，并强制执行安全策略。"
                        },
                        "fr": {
                            "name": "services.description.hp_command_center",
                            "value": "Supervisez et gérez vos imprimantes et appliquez la conformité avec votre politique de sécurité à l’aide de HP Command Center v2."
                        },
                        "ru": {
                            "name": "services.description.hp_command_center",
                            "value": "Monitor and manage your printers and enforce compliance with your security policy using HP Command Center v2."
                        },
                        "ja": {
                            "name": "services.description.hp_command_center",
                            "value": "[HP Command Center v2]を使用してプリンターを監視および管理し、セキュリティ ポリシーへの準拠を確保します。"
                        },
                        "zh_TW": {
                            "name": "services.description.hp_command_center",
                            "value": "Monitor and manage your printers and enforce compliance with your security policy using HP Command Center v2."
                        },
                        "it": {
                            "name": "services.description.hp_command_center",
                            "value": "Monitora e gestisci le tue stampanti e imponi i tuoi criteri di sicurezza con HP Command Center v2."
                        },
                        "ko": {
                            "name": "services.description.hp_command_center",
                            "value": "HP Command Center v2를 사용하여 프린터를 모니터링 및 관리하고 보안 정책을 통해 규정을 준수하십시오."
                        },
                        "pt_BR": {
                            "name": "services.description.hp_command_center",
                            "value": "Monitore e gerencie suas impressoras e aplique a conformidade com sua política de segurança usando o HP Command Center v2."
                        },
                        "da": {
                            "name": "services.description.hp_command_center",
                            "value": "Overvåg, og administrer dine printere, og opnå endnu bedre overholdelse af krav til din sikkerhedspolitik ved hjælp af HP Command Center v2."
                        },
                        "de": {
                            "name": "services.description.hp_command_center",
                            "value": "Überwachen und verwalten Sie mit HP Command Center v2 Ihre Drucker und setzen Sie die Einhaltung Ihrer Sicherheitsrichtlinien durch."
                        },
                        "fi": {
                            "name": "services.description.hp_command_center",
                            "value": "Seuraa ja hallitse tulostimiasi ja pakota vaatimustenmukaisuus tietosuojakäytäntösi kanssa käyttämällä HP Command Center v2:ta."
                        },
                        "es": {
                            "name": "services.description.hp_command_center",
                            "value": "Controle y administre sus impresoras e imponga el cumplimiento con su política de seguridad usando HP Command Center v2."
                        },
                        "en": {
                            "name": "services.description.hp_command_center",
                            "value": "Monitor and manage your printers and enforce compliance with your security policy using HP Command Center v2."
                        },
                        "sv": {
                            "name": "services.description.hp_command_center",
                            "value": "Övervaka och hantera skrivare och kräv efterlevnad av säkerhetspolicyn med HP Command Center v2."
                        },
                        "pt_PT": {
                            "name": "services.description.hp_command_center",
                            "value": "Monitorize e efetue a gestão das suas impressoras e garanta a conformidade com a sua política de segurança com o HP Command Center v2."
                        },
                        "nl": {
                            "name": "services.description.hp_command_center",
                            "value": "Bewaak en beheer uw printers en dwing naleving af van uw beveiligingsbeleid met HP Command Center v2."
                        },
                        "no": {
                            "name": "services.description.hp_command_center",
                            "value": "Overvåk og administrer skrivere og håndhev samsvar med sikkerhetspolicyer ved hjelp av HP Command Center v2."
                        }
                    },
                    "imageLink": "/techpulse_assets/images/adminx_services_proactive_insights.jpg",
                    "baseDomains": {
                        "usdevms": "https://ecp.stage.portalshell.int.hp.com",
                        "usperfms": "https://ecp.stage.portalshell.int.hp.com",
                        "uspentestms": "https://ecp.stage.portalshell.int.hp.com",
                        "usstagingms": "https://ecp.stage.portalshell.int.hp.com",
                        "usprodms": "https://hp-commandcenter.com",
                        "eudevms": "https://ecp.stage.portalshell.int.hp.com",
                        "eustagingms": "https://ecp.stage.portalshell.int.hp.com",
                        "euprodms": "https://hp-commandcenter.com",
                        "default": "https://ecp.stage.portalshell.int.hp.com"
                    }
                },
                {
                    "name": "hp_connect",
                    "appSites": ["DAAS_TEST", "DAAS"],
                    "allowTrial": false,
                    "isVisibleToAppSwitcher": true,
                    "isVisibleToMyService": true,
                    "isVisibleToAllService": true,
                    "isVisibleToHelpSupport": false,
                    "isVisibleToLanding": true,
                    "isFreeActiveService": true,
                    "launchUrl": "/hpc",
                    "displayName": {
                        "zh_CN": {
                            "name": "services.displayName.hp_connect",
                            "value": "连接"
                        },
                        "fr": {
                            "name": "services.displayName.hp_connect",
                            "value": "Connecter"
                        },
                        "ru": {
                            "name": "services.displayName.hp_connect",
                            "value": "Connect"
                        },
                        "ja": {
                            "name": "services.displayName.hp_connect",
                            "value": "接続"
                        },
                        "zh_TW": {
                            "name": "services.displayName.hp_connect",
                            "value": "Connect"
                        },
                        "it": {
                            "name": "services.displayName.hp_connect",
                            "value": "Connetti"
                        },
                        "ko": {
                            "name": "services.displayName.hp_connect",
                            "value": "연결"
                        },
                        "pt_BR": {
                            "name": "services.displayName.hp_connect",
                            "value": "Conectar"
                        },
                        "da": {
                            "name": "services.displayName.hp_connect",
                            "value": "Tilknyt"
                        },
                        "de": {
                            "name": "services.displayName.hp_connect",
                            "value": "Connect"
                        },
                        "fi": {
                            "name": "services.displayName.hp_connect",
                            "value": "Connect"
                        },
                        "es": {
                            "name": "services.displayName.hp_connect",
                            "value": "Conectar"
                        },
                        "en": {
                            "name": "services.displayName.hp_connect",
                            "value": "Connect"
                        },
                        "sv": {
                            "name": "services.displayName.hp_connect",
                            "value": "Anslut"
                        },
                        "pt_PT": {
                            "name": "services.displayName.hp_connect",
                            "value": "Ligar"
                        },
                        "nl": {
                            "name": "services.displayName.hp_connect",
                            "value": "Verbinden"
                        },
                        "no": {
                            "name": "services.displayName.hp_connect",
                            "value": "Koble til"
                        }
                    },
                    "details": {
                        "detailsUrl": "/hpc/",
                        "redirectUrls": null
                    },
                    "icon": {
                        "initials": "CO",
                        "textColor": "#212121",
                        "bgColor": "#FFE6FA",
                        "fillColor": "#F385E1"
                    },
                    "isInternal": false,
                    "defaultOnboardingStatus": "COMPLETED",
                    "description": {
                        "zh_CN": {
                            "name": "services.description.hp_connect",
                            "value": "创建策略，以便为 Intune 管理的 HP 端点自动管理 BIOS 设置、BIOS 身份验证和 BIOS 更新。"
                        },
                        "fr": {
                            "name": "services.description.hp_connect",
                            "value": "Créez des politiques pour gérer automatiquement les paramètres du BIOS, l'authentification du BIOS et les mises à jour du BIOS pour vos points de terminaison HP managés par Intune."
                        },
                        "ru": {
                            "name": "services.description.hp_connect",
                            "value": "Create policies to automatically manage BIOS settings, BIOS Authentication, and BIOS updates for your Intune-managed HP endpoints."
                        },
                        "ja": {
                            "name": "services.description.hp_connect",
                            "value": "ポリシーを作成することで、[Intune]で管理されるHPエンドポイントに対するBIOS設定、BIOS認証、およびBIOSアップデートの自動管理を可能にします。"
                        },
                        "zh_TW": {
                            "name": "services.description.hp_connect",
                            "value": "Create policies to automatically manage BIOS settings, BIOS Authentication, and BIOS updates for your Intune-managed HP endpoints."
                        },
                        "it": {
                            "name": "services.description.hp_connect",
                            "value": "Crea criteri per gestire automaticamente le impostazioni del BIOS, l'autenticazione del BIOS e gli aggiornamenti del BIOS per i tuoi endpoint gestiti da Intune."
                        },
                        "ko": {
                            "name": "services.description.hp_connect",
                            "value": "Intune 관리 HP 엔드포인트에 대한 BIOS 설정, BIOS 인증, BIOS 업데이트를 자동으로 관리하는 정책을 생성할 수 있습니다."
                        },
                        "pt_BR": {
                            "name": "services.description.hp_connect",
                            "value": "Crie políticas para gerenciar automaticamente configurações de BIOS, autenticação de BIOS e atualizações de BIOS para seus terminais HP gerenciados pelo Intune."
                        },
                        "da": {
                            "name": "services.description.hp_connect",
                            "value": "Opret politikker til automatiske at administrere BIOS-indstillinger, BIOS-godkendelser og BIOS-opdateringer for dine Intune-administrerede HP-endpoints."
                        },
                        "de": {
                            "name": "services.description.hp_connect",
                            "value": "Erstellen Sie Richtlinien zur automatischen Verwaltung von BIOS-Einstellungen, BIOS-Authentifizierung und BIOS-Updates für Ihre über Intune verwalteten HP Endpunkte."
                        },
                        "fi": {
                            "name": "services.description.hp_connect",
                            "value": "Luo käytäntöjä hallinnoidaksesi automaattisesti BIOS-asetuksia, BIOS-todennusta ja BIOS-päivityksiä Intune-hallituissa päätelaitteissa."
                        },
                        "es": {
                            "name": "services.description.hp_connect",
                            "value": "Cree políticas para administrar automáticamente la configuración del BIOS, la autenticación del BIOS y las actualizaciones del BIOS para sus puntos de conexión HP administrados por Intune."
                        },
                        "en": {
                            "name": "services.description.hp_connect",
                            "value": "Create policies to automatically manage BIOS settings, BIOS Authentication, and BIOS updates for your Intune-managed HP endpoints."
                        },
                        "sv": {
                            "name": "services.description.hp_connect",
                            "value": "Skapa policyer för att automatiskt hantera BIOS-inställningar, BIOS-autentisering och BIOS-uppdateringar, för Intune-hanterade HP-enheter."
                        },
                        "pt_PT": {
                            "name": "services.description.hp_connect",
                            "value": "Crie políticas para gerir automaticamente as definições do BIOS, a autenticação do BIOS e as atualizações do BIOS para os seus endpoints HP geridos pelo Intune."
                        },
                        "nl": {
                            "name": "services.description.hp_connect",
                            "value": "Maak beleid voor het automatisch beheren van BIOS-instellingen, BIOS-verificatie en BIOS-updates voor uw Intune-beheerde HP eindpunten."
                        },
                        "no": {
                            "name": "services.description.hp_connect",
                            "value": "Opprett policyer for å administrere BIOS-innstillinger, BIOS-godkjenning og BIOS-oppdateringer automatisk for Intune-administrerte HP-endepunkter."
                        }
                    },
                    "learnMoreLinks": {
                        "da": "",
                        "de": "",
                        "en": "/connect/learnmore",
                        "es": "",
                        "fi": "",
                        "fr": "",
                        "it": "",
                        "ja": "",
                        "no": "",
                        "nl": "",
                        "pt-BR": "",
                        "pt-PT": "",
                        "sv": "",
                        "zh-CN": ""
                    },
                    "imageLink": "/techpulse_assets/images/adminx_services_hp_connect.jpg"
                },
                {
                    "name": "hp_poly",
                    "appSites": ["DAAS_TEST", "DAAS"],
                    "allowTrial": false,
                    "isVisibleToAppSwitcher": true,
                    "isVisibleToMyService": true,
                    "isVisibleToAllService": true,
                    "isVisibleToHelpSupport": false,
                    "isVisibleToLanding": true,
                    "isFreeActiveService": true,
                    "launchUrl": "https://lens.poly.com/",
                    "displayName": {
                        "zh_CN": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "fr": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "ru": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "ja": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "zh_TW": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "it": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "ko": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "pt_BR": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "da": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "de": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "fi": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "es": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "en": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "sv": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "pt_PT": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "nl": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        },
                        "no": {
                            "name": "services.displayName.hp_poly",
                            "value": "Poly Lens"
                        }
                    },
                    "details": {
                        "detailsUrl": "https://www.hp.com/us-en/poly/software-and-services/software/poly-lens.html",
                        "redirectUrls": null
                    },
                    "icon": {
                        "initials": "PL",
                        "textColor": "#212121",
                        "bgColor": "#EE88DE",
                        "fillColor": "#F9C086"
                    },
                    "isInternal": false,
                    "defaultOnboardingStatus": "COMPLETED",
                    "description": {
                        "zh_CN": {
                            "name": "services.description.hp_poly",
                            "value": "为 IT 人员提供重要工具，使其能够部署、管理、监控其 UC 投资并收集有价值的洞见。"
                        },
                        "fr": {
                            "name": "services.description.hp_poly",
                            "value": "Donnez au service informatique les outils essentiels pour déployer, gérer, superviser et recueillir des informations précieuses sur leur investissement en termes de processeur."
                        },
                        "ru": {
                            "name": "services.description.hp_poly",
                            "value": "Empower IT with the critical tools to deploy, manage, monitor & gather valuable insights into their UC investments."
                        },
                        "ja": {
                            "name": "services.description.hp_poly",
                            "value": "UC投資に関する貴重なインサイトを展開、管理、監視、収集するための重要なツールをIT部門に提供します。"
                        },
                        "zh_TW": {
                            "name": "services.description.hp_poly",
                            "value": "Empower IT with the critical tools to deploy, manage, monitor & gather valuable insights into their UC investments."
                        },
                        "it": {
                            "name": "services.description.hp_poly",
                            "value": "Fornisci all’IT gli strumenti fondamentali per distribuire, gestire, monitorare e raccogliere informazioni preziose sugli investimenti UC."
                        },
                        "ko": {
                            "name": "services.description.hp_poly",
                            "value": "IT가 UC 투자에 관한 유용한 인사이트를 배포, 관리, 모니터링 및 수집하기 위한 중요한 도구 제공하십시오."
                        },
                        "pt_BR": {
                            "name": "services.description.hp_poly",
                            "value": "Capacite a TI com as ferramentas críticas para implantar, gerenciar, monitorar e reunir insights valiosos em seus investimentos de UC."
                        },
                        "da": {
                            "name": "services.description.hp_poly",
                            "value": "Giv IT ekstra muligheder med vigtige værktøjer til implementer, administration, overvågning og indsamling af værdifulde indsigter i deres UC-investeringer."
                        },
                        "de": {
                            "name": "services.description.hp_poly",
                            "value": "Statten Sie die IT-Abteilung mit wichtigen Tools zum Bereitstellen, Verwalten, Überwachen und Gewinnen von wertvollen Erkenntnissen zu ihren UC-Investitionen aus."
                        },
                        "fi": {
                            "name": "services.description.hp_poly",
                            "value": "Tehosta IT-järjestelmääsi kriittisillä työkaluilla, joilla voit ottaa käyttöön, hallita, seurata ja kerätä arvokkaita tietoja UC-investoinneista."
                        },
                        "es": {
                            "name": "services.description.hp_poly",
                            "value": "Empodere al equipo de TI con herramientas críticas para implementar, administrar, supervisar y recopilar conocimiento valioso en sus inversiones de UC."
                        },
                        "en": {
                            "name": "services.description.hp_poly",
                            "value": "Empower IT with the critical tools to deploy, manage, monitor & gather valuable insights into their UC investments."
                        },
                        "sv": {
                            "name": "services.description.hp_poly",
                            "value": "Ge IT-team bättre möjligheter med de kritiska verktygen som behövs för att driftsätta, hantera, övervaka och samla in värdefulla insikter om UC-investeringar."
                        },
                        "pt_PT": {
                            "name": "services.description.hp_poly",
                            "value": "Capacite as TI com ferramentas críticas para implementar, gerir, monitorizar e reunir informações valiosas nos seus investimentos UC."
                        },
                        "nl": {
                            "name": "services.description.hp_poly",
                            "value": "Zorg dat uw IT de essentiële tools heeft voor het implementeren, beheren, bewaken en verzamelen van inzichten in hun UC-investeringen."
                        },
                        "no": {
                            "name": "services.description.hp_poly",
                            "value": "Styrk IT med kritisk verktøy som trengs for å distribuere, administrere, overvåke og samle inn verdifull innsikt i UC-investeringer."
                        }
                    },
                    "learnMoreLinks": {
                        "da": "",
                        "de": "",
                        "en": "https://www.hp.com/us-en/poly/software-and-services/software/poly-lens.html",
                        "es": "",
                        "fi": "",
                        "fr": "",
                        "it": "",
                        "ja": "",
                        "no": "",
                        "nl": "",
                        "pt-BR": "",
                        "pt-PT": "",
                        "sv": "",
                        "zh-CN": ""
                    },
                    "imageLink": "/techpulse_assets/images/adminx_services_poly.jpg"
                }
            ],
            "icon": {
                "initials": "Management",
                "textColor": "#212121",
                "bgColor": "#CAF3FF",
                "fillColor": "#F385E1"
            }
        },
        "support": {
            "title": {
                "zh_CN": {
                    "name": "categories.displayName.support",
                    "value": "支持"
                },
                "fr": {
                    "name": "categories.displayName.support",
                    "value": "Support"
                },
                "ru": {
                    "name": "categories.displayName.support",
                    "value": "Support"
                },
                "ja": {
                    "name": "categories.displayName.support",
                    "value": "サポート"
                },
                "zh_TW": {
                    "name": "categories.displayName.support",
                    "value": "Support"
                },
                "it": {
                    "name": "categories.displayName.support",
                    "value": "Supporto"
                },
                "ko": {
                    "name": "categories.displayName.support",
                    "value": "지원"
                },
                "pt_BR": {
                    "name": "categories.displayName.support",
                    "value": "Suporte"
                },
                "da": {
                    "name": "categories.displayName.support",
                    "value": "Support"
                },
                "de": {
                    "name": "categories.displayName.support",
                    "value": "Support"
                },
                "fi": {
                    "name": "categories.displayName.support",
                    "value": "Tuki"
                },
                "es": {
                    "name": "categories.displayName.support",
                    "value": "Soporte"
                },
                "en": {
                    "name": "categories.displayName.support",
                    "value": "Support"
                },
                "sv": {
                    "name": "categories.displayName.support",
                    "value": "Support"
                },
                "pt_PT": {
                    "name": "categories.displayName.support",
                    "value": "Suporte"
                },
                "nl": {
                    "name": "categories.displayName.support",
                    "value": "Ondersteuning"
                },
                "no": {
                    "name": "categories.displayName.support",
                    "value": "Støtte"
                }
            },
            "services": [
                {
                    "name": "hp_care_pack",
                    "appSites": ["DAAS_TEST", "DAAS"],
                    "allowTrial": false,
                    "isVisibleToAppSwitcher": true,
                    "isVisibleToMyService": true,
                    "isVisibleToAllService": true,
                    "isVisibleToHelpSupport": true,
                    "isVisibleToLanding": true,
                    "launchUrl": "/activeCare",
                    "displayName": {
                        "zh_CN": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "fr": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "ru": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "ja": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "zh_TW": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "it": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "ko": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "pt_BR": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "da": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "de": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "fi": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "es": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "en": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "sv": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "pt_PT": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "nl": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        },
                        "no": {
                            "name": "services.displayName.hp_care_pack",
                            "value": "Active Care"
                        }
                    },
                    "details": {
                        "detailsUrl": "/activeCare",
                        "redirectUrls": null
                    },
                    "icon": {
                        "initials": "AC",
                        "textColor": "#212121",
                        "bgColor": "#CAF3FF",
                        "fillColor": "#F9C086"
                    },
                    "isInternal": true,
                    "defaultOnboardingStatus": "COMPLETED",
                    "description": {
                        "zh_CN": {
                            "name": "services.description.hp_care_pack",
                            "value": "为企业客户提供一套设备保护、支持和维修服务，使他们能够合理分配时间，在办公室内、差旅途中和远程工作中游刃有余地开展工作。"
                        },
                        "fr": {
                            "name": "services.description.hp_care_pack",
                            "value": "Une suite de services de protection, de prise en charge et de réparation des périphériques pour les clients professionnels qui partagent leur temps entre le bureau, les déplacements et le travail à distance."
                        },
                        "ru": {
                            "name": "services.description.hp_care_pack",
                            "value": "A suite of device protection, support, and repair services for business customers who split their time between the office, travel, and remote work."
                        },
                        "ja": {
                            "name": "services.description.hp_care_pack",
                            "value": "オフィス、出張、およびリモート ワークのすべてに時間を費やすビジネス カスタマー向けに、デバイス保護、サポート、および修理サービスのスイートを提供します。"
                        },
                        "zh_TW": {
                            "name": "services.description.hp_care_pack",
                            "value": "A suite of device protection, support, and repair services for business customers who split their time between the office, travel, and remote work."
                        },
                        "it": {
                            "name": "services.description.hp_care_pack",
                            "value": "Una suite di servizi di protezione, assistenza e riparazione dei dispositivi per i clienti aziendali che si dividono tra ufficio, viaggi e lavoro in remoto."
                        },
                        "ko": {
                            "name": "services.description.hp_care_pack",
                            "value": "사무실, 출장, 원격 근무를 오가며 시간을 보내는 비즈니스 고객을 위한 완벽한 장치 보호, 지원, 복구 서비스 제품군입니다."
                        },
                        "pt_BR": {
                            "name": "services.description.hp_care_pack",
                            "value": "Um conjunto de serviços de proteção, suporte e reparo de dispositivos para clientes corporativos que precisam dividir seu tempo entre escritório, viagens e trabalho remoto."
                        },
                        "da": {
                            "name": "services.description.hp_care_pack",
                            "value": "En række enhedsbeskyttelses-, support- og reparationstjenester til virksomhedskunder, der arbejder både på kontoret, på farten og via fjernadgang."
                        },
                        "de": {
                            "name": "services.description.hp_care_pack",
                            "value": "Eine Suite von Services für Geräteschutz, -support und -reparaturen für Geschäftsbenutzer*innen, die im Büro, unterwegs und an Remotestandorten arbeiten."
                        },
                        "fi": {
                            "name": "services.description.hp_care_pack",
                            "value": "Paketti, joka sisältää laitteiden suojauksen, tuen ja korjauspalvelut yritysasiakkaille, jotka jakavat aikansa toimiston, matkustamisen ja etätyöskentelyn välille."
                        },
                        "es": {
                            "name": "services.description.hp_care_pack",
                            "value": "Un conjunto con protección de dispositivos, soporte y servicios de reparación para clientes empresariales que dividen su tiempo entre la oficina, viajes y trabajo remoto."
                        },
                        "en": {
                            "name": "services.description.hp_care_pack",
                            "value": "A suite of device protection, support, and repair services for business customers who split their time between the office, travel, and remote work."
                        },
                        "sv": {
                            "name": "services.description.hp_care_pack",
                            "value": "En uppsättning enhetsskydd, -support och -reparationstjänster för företagskunder som spenderar tid på kontoret, resor och även arbetar på distans."
                        },
                        "pt_PT": {
                            "name": "services.description.hp_care_pack",
                            "value": "Um conjunto de serviços de proteção, suporte e reparação de dispositivos para clientes empresariais que dividem o seu tempo entre o escritório, as viagens e o trabalho remoto."
                        },
                        "nl": {
                            "name": "services.description.hp_care_pack",
                            "value": "Een reeks met apparaatbescherming, ondersteuning en reparatieservices voor zakelijke klanten die hun tijd verdelen tussen kantoor, reizen en werken op afstand."
                        },
                        "no": {
                            "name": "services.description.hp_care_pack",
                            "value": "En pakke med enhetsbeskyttelse, kundestøtte og reparasjonstjenester for bedriftskunder som jobber både på kontoret, mens de reiser og hjemme."
                        }
                    },
                    "learnMoreLinks": {
                        "da": "https://www.hp.com/dk-da/services/active-care.html",
                        "de": "https://www.hp.com/de-de/services/active-care.html",
                        "en": "https://www.hp.com/us-en/services/active-care.html",
                        "es": "https://www.hp.com/es-es/services/active-care.html",
                        "fi": "https://www.hp.com/fi-fi/services/active-care.html",
                        "fr": "https://www.hp.com/fr-fr/services/active-care.html",
                        "it": "https://www.hp.com/it-it/services/active-care.html",
                        "ja": "",
                        "no": "",
                        "nl": "https://www.hp.com/nl-nl/services/active-care.html",
                        "pt-BR": "https://www.hp.com/br-pt/services/active-care.html",
                        "pt-PT": "https://www.hp.com/pt-pt/services/active-care.html",
                        "sv": "https://www.hp.com/se-sv/services/active-care.html",
                        "zh-CN": ""
                    },
                    "imageLink": "/techpulse_assets/images/adminx_services_hp_care_pack.png"
                }
            ],
            "icon": {
                "initials": "Support",
                "textColor": "#212121",
                "bgColor": "#CAF3FF",
                "fillColor": "#F9C086"
            }
        },
        "managedServices": {
            "title": {
                "zh_CN": {
                    "name": "categories.displayName.managedServices",
                    "value": "托管服务"
                },
                "fr": {
                    "name": "categories.displayName.managedServices",
                    "value": "Services gérés"
                },
                "ru": {
                    "name": "categories.displayName.managedServices",
                    "value": "Managed Services"
                },
                "ja": {
                    "name": "categories.displayName.managedServices",
                    "value": "管理サービス"
                },
                "zh_TW": {
                    "name": "categories.displayName.managedServices",
                    "value": "Managed Services"
                },
                "it": {
                    "name": "categories.displayName.managedServices",
                    "value": "Servizi gestiti"
                },
                "ko": {
                    "name": "categories.displayName.managedServices",
                    "value": "관리형 서비스"
                },
                "pt_BR": {
                    "name": "categories.displayName.managedServices",
                    "value": "Managed Services"
                },
                "da": {
                    "name": "categories.displayName.managedServices",
                    "value": "Managed Services"
                },
                "de": {
                    "name": "categories.displayName.managedServices",
                    "value": "Verwaltete Services"
                },
                "fi": {
                    "name": "categories.displayName.managedServices",
                    "value": "Managed Services"
                },
                "es": {
                    "name": "categories.displayName.managedServices",
                    "value": "Servicios administrados"
                },
                "en": {
                    "name": "categories.displayName.managedServices",
                    "value": "Managed Services"
                },
                "sv": {
                    "name": "categories.displayName.managedServices",
                    "value": "Hanterade tjänster"
                },
                "pt_PT": {
                    "name": "categories.displayName.managedServices",
                    "value": "Managed Services"
                },
                "nl": {
                    "name": "categories.displayName.managedServices",
                    "value": "Managed Services"
                },
                "no": {
                    "name": "categories.displayName.managedServices",
                    "value": "Administrerte tjenester"
                }
            },
            "services": [
                {
                    "name": "hp_raas",
                    "appSites": ["DAAS_TEST", "DAAS"],
                    "allowTrial": false,
                    "isVisibleToAppSwitcher": true,
                    "isVisibleToMyService": true,
                    "isVisibleToAllService": true,
                    "isVisibleToHelpSupport": false,
                    "isVisibleToLanding": true,
                    "isFreeActiveService": true,
                    "launchUrl": "/raas",
                    "displayName": {
                        "zh_CN": {
                            "name": "services.displayName.hp_raas",
                            "value": "托管协作服务"
                        },
                        "fr": {
                            "name": "services.displayName.hp_raas",
                            "value": "Service de collaboration géré"
                        },
                        "ru": {
                            "name": "services.displayName.hp_raas",
                            "value": "Managed Collaboration Service"
                        },
                        "ja": {
                            "name": "services.displayName.hp_raas",
                            "value": "管理コラボレーション サービス"
                        },
                        "zh_TW": {
                            "name": "services.displayName.hp_raas",
                            "value": "Managed Collaboration Service"
                        },
                        "it": {
                            "name": "services.displayName.hp_raas",
                            "value": "Servizio di collaborazione gestito"
                        },
                        "ko": {
                            "name": "services.displayName.hp_raas",
                            "value": "관리형 공동 작업 서비스"
                        },
                        "pt_BR": {
                            "name": "services.displayName.hp_raas",
                            "value": "Serviço de Colaboração Gerenciado"
                        },
                        "da": {
                            "name": "services.displayName.hp_raas",
                            "value": "Tjenesten Administreret samarbejde"
                        },
                        "de": {
                            "name": "services.displayName.hp_raas",
                            "value": "Verwalteter Service für Zusammenarbeit"
                        },
                        "fi": {
                            "name": "services.displayName.hp_raas",
                            "value": "Managed Collaboration Service"
                        },
                        "es": {
                            "name": "services.displayName.hp_raas",
                            "value": "Managed Collaboration Service"
                        },
                        "en": {
                            "name": "services.displayName.hp_raas",
                            "value": "Managed Collaboration Service"
                        },
                        "sv": {
                            "name": "services.displayName.hp_raas",
                            "value": "Hanterade samarbetstjänster"
                        },
                        "pt_PT": {
                            "name": "services.displayName.hp_raas",
                            "value": "Managed Collaboration Service"
                        },
                        "nl": {
                            "name": "services.displayName.hp_raas",
                            "value": "Managed Collaboration Service"
                        },
                        "no": {
                            "name": "services.displayName.hp_raas",
                            "value": "Administrert samarbeidstjeneste"
                        }
                    },
                    "details": {
                        "detailsUrl": "/raas",
                        "redirectUrls": null
                    },
                    "icon": {
                        "initials": "MC",
                        "textColor": "#212121",
                        "bgColor": "#A482FD",
                        "fillColor": "#F9C086"
                    },
                    "isInternal": true,
                    "defaultOnboardingStatus": "COMPLETED",
                    "description": {
                        "zh_CN": {
                            "name": "services.description.hp_raas",
                            "value": "借助灵活、可靠、可管理的解决方案，确保每个会议室都支持视频通话，从而获得出色的会议体验。"
                        },
                        "fr": {
                            "name": "services.description.hp_raas",
                            "value": "Assurez-vous que chaque salle de conférence est équipée d’un système vidéo afin d’organiser des réunions exceptionnelles grâce à des solutions flexibles, fiables et gérées."
                        },
                        "ru": {
                            "name": "services.description.hp_raas",
                            "value": "Ensure every conference room is video enabled for exceptional meetings with flexible, reliable, managed solutions."
                        },
                        "ja": {
                            "name": "services.description.hp_raas",
                            "value": "柔軟性と信頼性に優れた管理ソリューションにより、すべての会議室でビデオ対応の効果的な会議を実現します。"
                        },
                        "zh_TW": {
                            "name": "services.description.hp_raas",
                            "value": "Ensure every conference room is video enabled for exceptional meetings with flexible, reliable, managed solutions."
                        },
                        "it": {
                            "name": "services.description.hp_raas",
                            "value": "Assicurati che ogni sala conferenze sia abilitata al video per riunioni eccezionali con soluzioni flessibili, affidabili e gestite."
                        },
                        "ko": {
                            "name": "services.description.hp_raas",
                            "value": "유연하고 안정적인 관리형 솔루션을 통해 회의를 성공적으로 진행할 수 있도록 모든 회의실에 동영상을 지원합니다."
                        },
                        "pt_BR": {
                            "name": "services.description.hp_raas",
                            "value": "Assegure-se de que todas as salas de conferência estejam habilitadas com vídeo para reuniões excepcionais com soluções flexíveis, confiáveis e gerenciadas."
                        },
                        "da": {
                            "name": "services.description.hp_raas",
                            "value": "Kontroller, at alle mødelokaler er videoaktiverede, så du får mulighed for at afholde enestående møder med fleksible, pålidelige og administrerede løsninger."
                        },
                        "de": {
                            "name": "services.description.hp_raas",
                            "value": "Stellen Sie durch flexible und zuverlässige verwaltete Lösungen sicher, dass jeder Konferenzraum über Video-Unterstützung verfügt, um reibungslose Meetings abzuhalten."
                        },
                        "fi": {
                            "name": "services.description.hp_raas",
                            "value": "Varmista, että jokaisessa kokoushuoneessa on videovalmiudet erinomaisiin kokouksiin joustavilla, luotettavilla ja hallinnoiduilla ratkaisuilla."
                        },
                        "es": {
                            "name": "services.description.hp_raas",
                            "value": "Asegúrese de que cada sala de videoconferencia tenga el mejor video para reuniones de alta calidad con soluciones administradas, flexibles y confiables."
                        },
                        "en": {
                            "name": "services.description.hp_raas",
                            "value": "Ensure every conference room is video enabled for exceptional meetings with flexible, reliable, managed solutions."
                        },
                        "sv": {
                            "name": "services.description.hp_raas",
                            "value": "Se till att alla konferensrum är videoaktiverade för fantastiska möten med flexibla, pålitliga och hanterade lösningar."
                        },
                        "pt_PT": {
                            "name": "services.description.hp_raas",
                            "value": "Certifique-se de que todas as salas de conferência têm o vídeo ativado para reuniões excecionais com soluções flexíveis, fiáveis e geridas."
                        },
                        "nl": {
                            "name": "services.description.hp_raas",
                            "value": "Zorg dat elke vergaderruimte geschikt is voor video voor uitzonderlijke vergaderingen met flexibele, betrouwbare, beheerde oplossingen."
                        },
                        "no": {
                            "name": "services.description.hp_raas",
                            "value": "Sørg for at video er aktivert i alle konferanserom for eksepsjonelle møter med fleksible, pålitelige og administrerte løsninger."
                        }
                    },
                    "learnMoreLinks": {
                        "da": "",
                        "de": "",
                        "en": "https://solutionssource.ext.hp.com/Solutions/ViewID/2544",
                        "es": "",
                        "fi": "",
                        "fr": "",
                        "it": "",
                        "ja": "",
                        "no": "",
                        "nl": "",
                        "pt-BR": "",
                        "pt-PT": "",
                        "sv": "",
                        "zh-CN": ""
                    },
                    "imageLink": "/techpulse_assets/images/adminx_services_hp_raas.jpg"
                }
            ],
            "icon": {
                "initials": "Managed Services",
                "textColor": "#212121",
                "bgColor": "#CAF3FF",
                "fillColor": "#A285F3"
            }
        },
        "other": {
            "title": {
                "zh_CN": {
                    "name": "categories.displayName.other",
                    "value": "其他"
                },
                "fr": {
                    "name": "categories.displayName.other",
                    "value": "Autre"
                },
                "ru": {
                    "name": "categories.displayName.other",
                    "value": "Other"
                },
                "ja": {
                    "name": "categories.displayName.other",
                    "value": "その他"
                },
                "zh_TW": {
                    "name": "categories.displayName.other",
                    "value": "Other"
                },
                "it": {
                    "name": "categories.displayName.other",
                    "value": "Altro"
                },
                "ko": {
                    "name": "categories.displayName.other",
                    "value": "기타"
                },
                "pt_BR": {
                    "name": "categories.displayName.other",
                    "value": "Outros"
                },
                "da": {
                    "name": "categories.displayName.other",
                    "value": "Andet"
                },
                "de": {
                    "name": "categories.displayName.other",
                    "value": "Sonstiges"
                },
                "fi": {
                    "name": "categories.displayName.other",
                    "value": "Muu"
                },
                "es": {
                    "name": "categories.displayName.other",
                    "value": "Otros"
                },
                "en": {
                    "name": "categories.displayName.other",
                    "value": "Other"
                },
                "sv": {
                    "name": "categories.displayName.other",
                    "value": "Annat"
                },
                "pt_PT": {
                    "name": "categories.displayName.other",
                    "value": "Outro"
                },
                "nl": {
                    "name": "categories.displayName.other",
                    "value": "Anders"
                },
                "no": {
                    "name": "categories.displayName.other",
                    "value": "Annet"
                }
            },
            "services": [
                {
                    "name": "employee_engagement",
                    "appSites": ["DAAS_TEST", "DAAS"],
                    "allowTrial": false,
                    "isVisibleToAppSwitcher": true,
                    "isVisibleToMyService": true,
                    "isVisibleToAllService": true,
                    "isVisibleToHelpSupport": false,
                    "isVisibleToLanding": true,
                    "isVisibleForTryIt": true,
                    "isFreeActiveService": true,
                    "launchUrl": "/experience/ui/dashboard",
                    "displayName": {
                        "zh_CN": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "fr": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "ru": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "ja": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "zh_TW": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "it": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "ko": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "pt_BR": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "da": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "de": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "fi": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "es": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "en": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "sv": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "pt_PT": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "nl": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        },
                        "no": {
                            "name": "services.displayName.employee_engagement",
                            "value": "Employee Engagement"
                        }
                    },
                    "icon": {
                        "initials": "EE",
                        "textColor": "#212121",
                        "bgColor": "#A482FD",
                        "fillColor": "#F9C086"
                    },
                    "isInternal": false,
                    "defaultOnboardingStatus": "COMPLETED",
                    "description": {
                        "zh_CN": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "fr": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "ru": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "ja": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "zh_TW": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "it": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "ko": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "pt_BR": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "da": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "de": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "fi": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "es": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "en": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "sv": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "pt_PT": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "nl": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        },
                        "no": {
                            "name": "services.description.employee_engagement",
                            "value": "Get insights and recommendations for improving profitability through enhanced employee engagement."
                        }
                    },
                    "learnMoreLinks": {
                        "da": "",
                        "de": "",
                        "en": "/experience/ui/dashboard",
                        "es": "",
                        "fi": "",
                        "fr": "",
                        "it": "",
                        "ja": "",
                        "no": "",
                        "nl": "",
                        "pt-BR": "",
                        "pt-PT": "",
                        "sv": "",
                        "zh-CN": ""
                    },
                    "imageLink": "/techpulse_assets/images/adminx_services_hp_connect.jpg"
                }
            ],
            "icon": {
                "initials": "Other",
                "textColor": "#212121",
                "bgColor": "#CAF3FF",
                "fillColor": "#F385E1"
            }
        }
    },
    "tools": {
        "other": {
            "title": {
                "zh_CN": {
                    "name": "categories.displayName.tools",
                    "value": "工具"
                },
                "fr": {
                    "name": "categories.displayName.tools",
                    "value": "Outils"
                },
                "ru": {
                    "name": "categories.displayName.tools",
                    "value": "Tools"
                },
                "ja": {
                    "name": "categories.displayName.tools",
                    "value": "ツール"
                },
                "zh_TW": {
                    "name": "categories.displayName.tools",
                    "value": "Tools"
                },
                "it": {
                    "name": "categories.displayName.tools",
                    "value": "Strumenti"
                },
                "ko": {
                    "name": "categories.displayName.tools",
                    "value": "도구"
                },
                "pt_BR": {
                    "name": "categories.displayName.tools",
                    "value": "Ferramentas"
                },
                "da": {
                    "name": "categories.displayName.tools",
                    "value": "Værktøjer"
                },
                "de": {
                    "name": "categories.displayName.tools",
                    "value": "Tools"
                },
                "fi": {
                    "name": "categories.displayName.tools",
                    "value": "Työkalut"
                },
                "es": {
                    "name": "categories.displayName.tools",
                    "value": "Herramientas"
                },
                "en": {
                    "name": "categories.displayName.tools",
                    "value": "Tools"
                },
                "sv": {
                    "name": "categories.displayName.tools",
                    "value": "Verktyg"
                },
                "pt_PT": {
                    "name": "categories.displayName.tools",
                    "value": "Ferramentas"
                },
                "nl": {
                    "name": "categories.displayName.tools",
                    "value": "Hulpprogramma's"
                },
                "no": {
                    "name": "categories.displayName.tools",
                    "value": "Verktøy"
                }
            },
            "services": [
                {
                    "name": "hp_cmsl",
                    "appSites": ["DAAS_TEST", "DAAS"],
                    "allowTrial": false,
                    "trialPlan": "",
                    "isVisibleToAppSwitcher": true,
                    "isVisibleToMyService": true,
                    "isVisibleToAllService": true,
                    "isVisibleToHelpSupport": false,
                    "isVisibleToLanding": true,
                    "isVisibleForTryIt": true,
                    "isFreeActiveService": false,
                    "launchUrl": "https://developers.hp.com/hp-client-management/doc/client-management-script-library",
                    "displayName": {
                        "zh_CN": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "fr": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "ru": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "ja": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "zh_TW": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "it": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "ko": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "pt_BR": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "da": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "de": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "fi": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "es": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "en": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "sv": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "pt_PT": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "nl": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        },
                        "no": {
                            "name": "services.displayName.hp_cmsl",
                            "value": "CMSL"
                        }
                    },
                    "details": {
                        "detailsUrl": "https://developers.hp.com/hp-client-management/doc/client-management-script-library",
                        "redirectUrls": null
                    },
                    "icon": {
                        "initials": "SL",
                        "textColor": "#212121",
                        "bgColor": "#FFE6FA",
                        "fillColor": "#F385E1"
                    },
                    "isInternal": true,
                    "defaultOnboardingStatus": "COMPLETED",
                    "onboardUrl": "https://developers.hp.com/hp-client-management/doc/client-management-script-library",
                    "description": {
                        "zh_CN": {
                            "name": "services.description.hp_cmsl",
                            "value": "使用我们的 PowerShell 模块自动执行 HP 商用电脑端点管理任务，例如更新驱动程序或配置 BIOS。"
                        },
                        "fr": {
                            "name": "services.description.hp_cmsl",
                            "value": "Utilisez nos modules PowerShell pour automatiser vos tâches de gestion de point de terminaison sur PC professionnel HP, comme la mise à jour des pilotes ou la configuration du BIOS."
                        },
                        "ru": {
                            "name": "services.description.hp_cmsl",
                            "value": "Use our PowerShell modules to automate your HP commercial PC endpoint management tasks such as updating drivers or configuring the BIOS."
                        },
                        "ja": {
                            "name": "services.description.hp_cmsl",
                            "value": "[PowerShell]モジュールを使用して、ドライバーの更新やBIOSの構成などのHP法人向けPCエンドポイントの管理タスクを自動化します。"
                        },
                        "zh_TW": {
                            "name": "services.description.hp_cmsl",
                            "value": "Use our PowerShell modules to automate your HP commercial PC endpoint management tasks such as updating drivers or configuring the BIOS."
                        },
                        "it": {
                            "name": "services.description.hp_cmsl",
                            "value": "Usa i nostri moduli PowerShell per automatizzare le attività di gestione endpoint dei tuoi PC commerciali HP, come l’aggiornamento dei driver o la configurazione del BIOS."
                        },
                        "ko": {
                            "name": "services.description.hp_cmsl",
                            "value": "HP의 PowerShell 모듈을 사용하여 드라이버 업데이트, BIOS 구성 등과 같은 HP 상업용 PC 끝점 관리 작업을 자동화할 수 있습니다."
                        },
                        "pt_BR": {
                            "name": "services.description.hp_cmsl",
                            "value": "Use nossos módulos do PowerShell para automatizar as tarefas de gerenciamento dos pontos de extremidade de PCs comerciais HP, como atualizar drivers ou configurar o BIOS."
                        },
                        "da": {
                            "name": "services.description.hp_cmsl",
                            "value": "Brug vores PowerShell-moduler til at automatisere din administrationsopgaver som f.eks. opdatering af drivere eller konfiguration af BIOS'en på dit kommercielle HP-pc-endpoint."
                        },
                        "de": {
                            "name": "services.description.hp_cmsl",
                            "value": "Verwenden Sie unsere PowerShell-Module, um Aufgaben in Bezug auf das Management Ihrer kommerziellen HP PC-Endgeräte zu automatisieren, wie etwa die Aktualisierung von Treibern oder die Konfiguration des BIOS."
                        },
                        "fi": {
                            "name": "services.description.hp_cmsl",
                            "value": "Käytä PowerShell-moduuleitamme HP:n kaupallisen päätelaitteen hallintatehtävien (kuten ohjainten päivityksen tai BIOS-asetusten) automatisointiin."
                        },
                        "es": {
                            "name": "services.description.hp_cmsl",
                            "value": "Use nuestros módulos PowerShell para automatizar tareas de administración en sus terminales PC HP de uso comercial, como actualización de controladores o configuración del BIOS."
                        },
                        "en": {
                            "name": "services.description.hp_cmsl",
                            "value": "Use our PowerShell modules to automate your HP commercial PC endpoint management tasks such as updating drivers or configuring the BIOS."
                        },
                        "sv": {
                            "name": "services.description.hp_cmsl",
                            "value": "Använd våra PowerShell-moduler för att automatisera hanteringen av HPs kommersiella enheter såsom att uppdatera drivrutiner eller konfigurera BIOS."
                        },
                        "pt_PT": {
                            "name": "services.description.hp_cmsl",
                            "value": "Utilize os nossos módulos PowerShell para automatizar as suas tarefas de gestão de terminais de PCs comerciais HP, como a atualização de controladores ou a configuração do BIOS."
                        },
                        "nl": {
                            "name": "services.description.hp_cmsl",
                            "value": "Gebruik onze PowerShell-modules om eindpuntbeheertaken van uw HP commerciële pc's te automatiseren, zoals het bijwerken van stuurprogramma's of het configureren van het BIOS."
                        },
                        "no": {
                            "name": "services.description.hp_cmsl",
                            "value": "Bruk PowerShell-moduler for å automatisere administrasjonsoppgaver for HP kommersielle PC-endepunkter, som for eksempel oppdatering av drivere eller konfigurering av BIOS."
                        }
                    },
                    "learnMoreLinks": {
                        "en": "https://developers.hp.com/hp-client-management/doc/client-management-script-library"
                    },
                    "imageLink": "/techpulse_assets/images/adminx_tools_cmsl.jpg"
                },
                {
                    "name": "hp_image_assistant",
                    "appSites": ["DAAS_TEST", "DAAS"],
                    "allowTrial": false,
                    "trialPlan": "",
                    "isVisibleToAppSwitcher": true,
                    "isVisibleToMyService": true,
                    "isVisibleToAllService": true,
                    "isVisibleToHelpSupport": false,
                    "isVisibleToLanding": true,
                    "isVisibleForTryIt": true,
                    "isFreeActiveService": false,
                    "launchUrl": "https://ftp.ext.hp.com/pub/caps-softpaq/cmit/HPIA.html",
                    "displayName": {
                        "zh_CN": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "fr": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "ru": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "ja": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "zh_TW": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "it": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "ko": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "pt_BR": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "da": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "de": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "fi": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "es": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "en": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "sv": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "pt_PT": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "nl": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        },
                        "no": {
                            "name": "services.displayName.hp_image_assistant",
                            "value": "Image Assistant"
                        }
                    },
                    "details": {
                        "detailsUrl": "https://ftp.ext.hp.com/pub/caps-softpaq/cmit/HPIA.html",
                        "redirectUrls": null
                    },
                    "icon": {
                        "initials": "IA",
                        "textColor": "#212121",
                        "bgColor": "#FFE6FA",
                        "fillColor": "#F385E1"
                    },
                    "isInternal": true,
                    "defaultOnboardingStatus": "COMPLETED",
                    "onboardUrl": "https://ftp.ext.hp.com/pub/caps-softpaq/cmit/HPIA.html",
                    "description": {
                        "zh_CN": {
                            "name": "services.description.hp_image_assistant",
                            "value": "无论是处于在线还是离线状态，都可通过 GUI 或命令行分析和更新 HP 商用 Windows 端点上的驱动程序、固件和 OEM 软件。"
                        },
                        "fr": {
                            "name": "services.description.hp_image_assistant",
                            "value": "Analysez et mettez à jour les pilotes, le microprogramme et le logiciel OEM sur vos points de terminaison Windows professionnels HP via l’interface utilisateur graphique ou la ligne de commande, dans des scénarios en ligne ou hors ligne."
                        },
                        "ru": {
                            "name": "services.description.hp_image_assistant",
                            "value": "Analyze and update drivers, firmware, and OEM software on your HP commercial Windows endpoints via GUI or command line in either online or offline scenarios."
                        },
                        "ja": {
                            "name": "services.description.hp_image_assistant",
                            "value": "オンラインまたはオフラインのシナリオで、GUIまたはコマンド ラインを使用して、HP法人向けWindowsエンドポイントのドライバー、ファームウェア、およびOEMソフトウェアを分析して更新します。"
                        },
                        "zh_TW": {
                            "name": "services.description.hp_image_assistant",
                            "value": "Analyze and update drivers, firmware, and OEM software on your HP commercial Windows endpoints via GUI or command line in either online or offline scenarios."
                        },
                        "it": {
                            "name": "services.description.hp_image_assistant",
                            "value": "Analizza e aggiorna i driver, il firmware e il software OEM sui tuoi endpoint Windows commerciali HP tramite interfaccia grafica (GUI) o riga di comando in scenari online o offline."
                        },
                        "ko": {
                            "name": "services.description.hp_image_assistant",
                            "value": "HP 상업용 Windows 끝점에서 GUI 또는 명령줄을 통해 온라인이나 오프라인 시나리오로 드라이버, 펌웨어 및 OEM 소프트웨어를 분석하고 업데이트할 수 있습니다."
                        },
                        "pt_BR": {
                            "name": "services.description.hp_image_assistant",
                            "value": "Analise e atualize drivers, firmware e software OEM nos seus pontos de extremidade Windows comerciais HP via GUI ou linha de comando, em situações on-line ou off-line."
                        },
                        "da": {
                            "name": "services.description.hp_image_assistant",
                            "value": "Analyser og opdater drivere, firmware og OEM-software på dine kommercielle HP Windows-endpoints via GUI eller kommandolinje både på kontoret, og når du offline."
                        },
                        "de": {
                            "name": "services.description.hp_image_assistant",
                            "value": "Analysieren und aktualisieren Sie über die GUI oder Befehlszeile entweder in Online- oder Offline-Szenarien Treiber, Firmware und OEM-Software auf Ihren kommerziellen HP Windows-Endgeräten."
                        },
                        "fi": {
                            "name": "services.description.hp_image_assistant",
                            "value": "Analysoi ja päivitä ohjaimia, laiteohjelmisto ja OEM-ohjelmistoja HP:n kaupallisissa Windows-päätteissä graafisen käyttöliittymän tai komentorivin kautta joko online- tai offline-tilassa."
                        },
                        "es": {
                            "name": "services.description.hp_image_assistant",
                            "value": "Analice y actualice controladores, firmware y software OEM en sus terminales HP de uso comercial con Windows mediante una interfaz de usuario gráfica o una línea de comandos, con o sin conexión."
                        },
                        "en": {
                            "name": "services.description.hp_image_assistant",
                            "value": "Analyze and update drivers, firmware, and OEM software on your HP commercial Windows endpoints via GUI or command line in either online or offline scenarios."
                        },
                        "sv": {
                            "name": "services.description.hp_image_assistant",
                            "value": "Analysera och uppdatera drivrutiner, inbyggd programvara och OEM-programvara på HPs kommersiella enheter med Windows via ett GUI eller en kommandorad – antingen online eller offline."
                        },
                        "pt_PT": {
                            "name": "services.description.hp_image_assistant",
                            "value": "Analise e atualize controladores, firmware e software OEM nos seus terminais Windows comerciais HP através da GUI ou da linha de comandos em cenários online ou offline."
                        },
                        "nl": {
                            "name": "services.description.hp_image_assistant",
                            "value": "Analyseer en werk stuurprogramma's, firmware en OEM-software bij op uw HP commerciële Windows-eindpunten via GUI of opdrachtregel in online of offline scenario's."
                        },
                        "no": {
                            "name": "services.description.hp_image_assistant",
                            "value": "Analyser og oppdater drivere, fastvare og OEM-programvare på HP kommersielle Windows-endepunkter via GUI eller kommandolinjen, enten i tilkoblede eller frakoblede scenarier."
                        }
                    },
                    "learnMoreLinks": {
                        "en": "https://ftp.ext.hp.com/pub/caps-softpaq/cmit/HPIA.html"
                    },
                    "imageLink": "/techpulse_assets/images/adminx_tools_hpia.jpg"
                }
            ],
            "icon": {
                "initials": "Tools",
                "textColor": "#212121",
                "bgColor": "#CAF3FF",
                "fillColor": "#F385E1"
            }
        }
    }
}
